import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpClientSecured} from '../services/http-client-secured';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as myGlobals from './../global';
import {IBusqueda, IMerchant} from './IMerchant';
import {IBin} from '../bines/bin';

@Injectable({
  providedIn: 'root'
})
export class MerchantsService {
  private comerciosURL = myGlobals.merchantApi + '/merchants-api/merchants';
  private buscarComercio = myGlobals.merchantApi + '/merchants-api/merchants/byFilter';
  private nuevoComercio = myGlobals.merchantApi + '/merchants-api/merchant';
  private actualizarComercio = myGlobals.merchantApi + '/merchants-api/merchant/';
  private ownershipTypes = myGlobals.merchantApi + '/merchants-api/catalog/ownership-types';
  private mcc = myGlobals.merchantApi + '/merchants-api/catalog/seller-mcc';
  private sellerStatus = myGlobals.merchantApi + '/merchants-api/catalog/seller-status';
  private sellerStatusDetail = myGlobals.merchantApi + '/merchants-api/catalog/seller-detail-status-codes';
  private currencies = myGlobals.merchantApi + '/merchants-api/catalog/currencies';
  private countries = myGlobals.merchantApi + '/merchants-api/catalog/countries';
  private states = myGlobals.merchantApi + '/merchants-api/catalog/country/';
  formData: IMerchant;
  busqueda: IBusqueda;

  constructor(private http: HttpClientSecured, private httpClientSecured: HttpClientSecured) {
  }

  getComercios() {
    console.log('getMerchants calles with httpClientSecured');
    return this.httpClientSecured.get<any>(this.comerciosURL);
  }

  getOwnershiptypes() {
    return this.httpClientSecured.get<any>(this.ownershipTypes);
  }

  getMCC() {
    return this.httpClientSecured.get<any>(this.mcc);
  }

  getSellerstatus() {
    return this.httpClientSecured.get<any>(this.sellerStatus);
  }

  getSellerstatusDetail() {
    return this.httpClientSecured.get<any>(this.sellerStatusDetail);
  }

  getCurrencies() {
    return this.httpClientSecured.get<any>(this.currencies);
  }

  getCountries() {
    return this.httpClientSecured.get<any>(this.countries);
  }

  getEstadosPais(countryCode: string) {
    return this.httpClientSecured.get<any>(this.states + countryCode + '/states');
  }

  getComercio(itemId: number): Observable<IMerchant | undefined> {
    return this.getComercios().pipe(map((comercios: IMerchant[]) => comercios.find(p => p.id === itemId)));
  }

  getComercioFiltro() {
    return this.httpClientSecured.post<any>(this.buscarComercio, this.busqueda);
  }

  addComercio() {
    return this.httpClientSecured.post<any>(this.nuevoComercio, this.formData);
  }

  // Amex rejects a setup with HTTP 200, so the failure only shows up in the response body.
  getSetupErrors(response: any): string[] {
    if (response == null || response.savedToDB !== false) {
      return [];
    }

    const serviceResponses = response.servicesResponseDetails || [];
    const messages: string[] = [];

    serviceResponses.forEach(serviceResponse => {
      if (serviceResponse.numberOfErrors > 0) {
        (serviceResponse.errors || []).forEach(error => {
          messages.push(serviceResponse.serviceName + ' ' + error.code + ': ' + error.message);
        });
      }
    });

    return messages.length > 0 ? messages : ['El comercio no pudo registrarse en Amex'];
  }

  updateComercio() {
    return this.httpClientSecured.put<any>(this.actualizarComercio + this.formData.id, this.formData);
  }
}
